import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-end"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = {
  key: 1,
  colspan: "1"
}
const _hoisted_11 = {
  key: 0,
  class: "hh-edit-row-two"
}
const _hoisted_12 = ["colspan"]
const _hoisted_13 = {
  key: 1,
  class: "hh-edit-row-two"
}
const _hoisted_14 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_HHPreadmissionNotesForm = _resolveComponent("HHPreadmissionNotesForm")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(`${_ctx.isEditRequested || _ctx.isViewRequested ? 'hh-edit-row-one' : _ctx.isDeleteRequested ? 'hh-delete-row' : ''}`)
    }, [
      _createElementVNode("td", null, _toDisplayString(_ctx.note.title), 1 /* TEXT */),
      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.note.date)), 1 /* TEXT */),
      _createElementVNode("td", null, _toDisplayString(_ctx.note.userName), 1 /* TEXT */),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            (_ctx.note.isCreatedUser)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!_ctx.isEditRequested)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn table-btn btn-outline-info",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditNote()))
                      }, _hoisted_3)), [
                        [_directive_tooltip, { title: 'Edit Note' }]
                      ])
                    : _createCommentVNode("v-if", true),
                  (!_ctx.isEditRequested)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn table-btn btn-outline-danger",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDeleteNote()))
                      }, _hoisted_5)), [
                        [_directive_tooltip, { title: 'Delete Note' }]
                      ])
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (!_ctx.isViewRequested)
                    ? _withDirectives((_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn table-btn btn-outline-info",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openViewNote()))
                      }, _hoisted_7)), [
                        [_directive_tooltip, { title: 'View Note' }]
                      ])
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */)),
            (_ctx.isEditRequested)
              ? (_openBlock(), _createElementBlock("i", _hoisted_8, "Edit In Progress"))
              : _createCommentVNode("v-if", true),
            (_ctx.isViewRequested)
              ? (_openBlock(), _createElementBlock("i", _hoisted_9, "View In Progress"))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "delete",
              "is-in-progress": _ctx.isDeleteInProgress,
              ok: _ctx.deleteNote,
              cancel: _ctx.cancelDeleteNote
            }, null, 8 /* PROPS */, ["is-in-progress", "ok", "cancel"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (_ctx.isEditRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
          _createElementVNode("td", { colspan: _ctx.columns }, [
            _createVNode(_component_HHPreadmissionNotesForm, {
              note: _ctx.note,
              "referral-id": _ctx.referralId,
              "show-note-form": _ctx.isEditRequested,
              "reset-list": _ctx.resetList,
              referral: _ctx.referral,
              accountId: _ctx.accountId,
              application: _ctx.application,
              closeNoteForm: _ctx.closeEditNote
            }, null, 8 /* PROPS */, ["note", "referral-id", "show-note-form", "reset-list", "referral", "accountId", "application", "closeNoteForm"])
          ], 8 /* PROPS */, _hoisted_12)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isViewRequested)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
          _createElementVNode("td", { colspan: _ctx.columns }, [
            _createVNode(_component_HHPreadmissionNotesForm, {
              "is-read-only": true,
              "show-note-form": _ctx.isViewRequested,
              note: _ctx.note,
              referral: _ctx.referral,
              closeNoteForm: _ctx.closeViewNote
            }, null, 8 /* PROPS */, ["show-note-form", "note", "referral", "closeNoteForm"])
          ], 8 /* PROPS */, _hoisted_14)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}